// Instância Axios dedicada à API de Anexo de GEDs (upload/vínculo de documentos
// com Requerimento/Protocolo). Cada requisição recebe automaticamente o header
// Authorization: Bearer {token}, lido do localStorage, e desloga o usuário se o
// token expirar/for inválido. Sem Content-Type fixo: os envios são multipart/form-data
// (FormData), e o axios define o boundary certo sozinho quando não forçamos o header.

import axios from 'axios';

const documentosApi = axios.create({
  baseURL: process.env.REACT_APP_GED_API_URL,
  timeout: 60000
});

documentosApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

documentosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default documentosApi;
